import React from 'react';
import Modal from '../../Components/Modal';
import Form, { Actions, BlockDays, DateTime, EventTriggers, ItemisationAdjustment, OptionalTime, RequiredValidator, User } from '../../Components/Form';
import { useCustomer } from '../../Data/Customers';
import { eventTriggers } from '../../Data/Misc';
import Icon from '../../Components/Icons/Icon';
import { deviceIsMd } from '../../Services/helpers';

const ScheduleJob = ({job, onClose, then}) => {
    return <Modal title="Schedule job" isOpen={!!job} setIsOpen={onClose} dismissible>
        {job && <Inner job={job} then={then} />}
    </Modal>
}

const Inner = ({job, then}) => {
    const {scheduleJob, unscheduleJob} = useCustomer(job?.customerId);

    const formData = {
        date: job?.scheduledDate,
        estimatedTime: job?.estimatedTime,
        assignedTo: job?.assignedTo,
        itemisationAdjustment: job?.itemisationAdjustment,
        blockDays: job?.blockDays ?? null,
        actionSource: 'Individual',
    };

    return <Form data={formData}
            onSubmit={d => scheduleJob(job.id, d)}
            afterSubmit={then}
            closeModalOnSubmit
        >
        <DateTime name="date" label="Date" time={false} validators={[RequiredValidator]} showDatePrompts />
        <OptionalTime name="estimatedTime" label="Time" toggleLabel="Set a time for the job" step="300" />
        <User name="assignedTo" label="Assign to" validators={[]} />
        <BlockDays />
        <ItemisationAdjustment originalCost={job.cost} help="Adjust the cost for this occurrence only" />
        <EventTriggers triggers={[eventTriggers.SEND_NOTIFICATIONS]} />
        <Actions
            leftExtra={{
                className: 'btn-light',
                // icon: 'CalendarX',
                // label: 'Unschedule',
                label: deviceIsMd() ? 'Unschedule' : <Icon icon="CalendarX" />,
                closeModal: true,
                hide: !job.scheduledDate,
                onClick: async () => {
                    await unscheduleJob(job.id);
                    then();
                }
            }}
            submit={{label: 'Schedule'}}
            cancel
        />
    </Form>
}

export default ScheduleJob;
